import React, { useCallback, useEffect, useState } from 'react';
import './../Form.scss';
import './CampanhasForm.scss';
import { useHistory, useParams } from 'react-router';
import service from '../../../services/campanhas';
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import { hasText, isDate, isHour, maskDate, maskHour } from '../../../utils/utils';
import { actions as actionsSite } from './../../../redux/actions/site';
import { useDispatch } from 'react-redux';
import { date2Front } from '../../../utils/converts';

const CampanhasForm = props => {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const history = useHistory();
    const params = useParams();
    const [campanha, setCampanha] = useState({});

    const { register, handleSubmit, errors } = useForm();

    const onSubmit = data => {
        save(data);
    };

    const carregarCampanha = useCallback(async (id) => {
        const campanhaInicial = await service.getById(id);
        setCampanha(campanhaInicial);
        setLoading(false);
    }, []);


    useEffect(() => {
        const run = async () => {
            if (params.id) {
                carregarCampanha(params.id);
            } else {
                setLoading(false);
            }
        }
        run();
    }, [carregarCampanha, params.id]);

    const save = async (data) => {
        dispatch(actionsSite.setLoadingMsg("Enviando dados..."));
        const res = await service.upsert(data, campanha._id);
        dispatch(actionsSite.setLoadingMsg(res.msg));
        setTimeout(() => {
            dispatch(actionsSite.setLoadingMsg(""));
            if (!params.id && !res.erro) {
                history.push('/painel/campanhas');
            }
        }, 3000);
    }

    return (
        <>
            {!loading &&
                <div className="form campanhas">
                    <form onSubmit={handleSubmit(onSubmit)} className="formModule branco campanhasForm">
                        <div className="acoes">
                            <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> {params.id ? 'Editar' : 'Salvar'}</button>
                            <button type="button" className="cancelar" onClick={() => history.push('/painel/campanhas')}><FontAwesomeIcon icon={faBan} /> Cancelar</button>
                        </div>
                        <div className="break"></div>

                        <div className={errors.dataInicio ? "field error" : "field"}>
                            <input name="dataInicio" id="dataInicio" maxLength={10}
                                className={campanha.dataInicio && campanha.dataInicio !== "" ? "hasText" : ""} 
                                onKeyUp={(e) => { maskDate(e); hasText(e) }} type="text"
                                ref={register({ required: true, validate: { isDate: value => isDate(value) } })} defaultValue={date2Front(campanha.dataInicio)} />
                            <label htmlFor="dataInicio">Data de Início</label>
                        </div>

                        <div className={errors.dataFim ? "field error" : "field"}>
                            <input name="dataFim" id="dataFim" maxLength={10}
                                className={campanha.dataFim && campanha.dataFim !== "" ? "hasText" : ""} 
                                onKeyUp={(e) => { maskDate(e); hasText(e) }} type="text"
                                ref={register({ required: true, validate: { isDate: value => isDate(value) } })} defaultValue={date2Front(campanha.dataFim)} />
                            <label htmlFor="dataFim">Data de Fim</label>
                        </div>

                        <div className={errors.horaFim ? "field error" : "field"}>
                            <input name="horaFim" id="horaFim" maxLength={5}
                                className={campanha.horaFim && campanha.horaFim !== "" ? "hasText" : ""} 
                                onKeyUp={(e) => { maskHour(e); hasText(e) }} type="text"
                                ref={register({ required: true, validate: { isHour: value => isHour(value) } })} defaultValue={campanha.horaFim} />
                            <label htmlFor="dataFim">Hora Fim</label>
                        </div>

                        <div className={errors.dataEntrega ? "field error" : "field"}>
                            <input name="dataEntrega" id="dataEntrega" maxLength={10}
                                className={campanha.dataEntrega && campanha.dataEntrega !== "" ? "hasText" : ""} 
                                onKeyUp={(e) => { maskDate(e); hasText(e) }} type="text"
                                ref={register({ required: true, validate: { isDate: value => isDate(value) } })} defaultValue={date2Front(campanha.dataEntrega)} />
                            <label htmlFor="dataEntrega">Data de Entrega</label>
                        </div>

                        <div className={errors.codigo ? "field error" : "field"}>
                            <input className={campanha.codigo ? 'hasText' : ''} name="codigo" id="codigo" 
                            defaultValue={campanha.codigo} onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                            <label htmlFor="codigo">Código</label>
                        </div>
                        <div className="break"></div>
                        <div className="acoes">
                            <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> {params.id ? 'Editar' : 'Salvar'}</button>
                            <button type="button" className="cancelar" onClick={() => history.push('/painel/campanhas')}><FontAwesomeIcon icon={faBan} /> Cancelar</button>
                        </div>
                    </form>
                    {errors && Object.keys(errors).length > 0 &&
                        <div className="erros">
                            <div><FontAwesomeIcon icon={faTimes} /> Existem erros no formulário</div>
                        </div>
                    }
                </div>
            }
            {loading && "Carregando..."}
        </>
    )
}

export default CampanhasForm;